import axios from 'axios';
import { AxiosError } from 'axios';

/** API_URL env var */
declare const API_URL: string;

/** The axios isntance */
const instance = axios.create({
	withCredentials: false,
	baseURL: API_URL,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
});

/** Catcher for promises */
export function catcher(error: AxiosError) {
	return Promise.reject(error); // For Promise.all().catch
}

export default instance;
